import { GtmLoginMethod } from "@obg/gtm.types/adaptive";
import { LOGIN_CONSENTS_DIALOG_ID } from "@obg/mat.ui.common";
import { DialogLike } from "@obg/mat.ui.core";

import { LoginConsentsContainer } from "./login-consents.container";

export function loginConsentsDialogFactory(
	authMethod?: GtmLoginMethod | undefined
): DialogLike<LoginConsentsContainer> {
	return {
		dialogId: LOGIN_CONSENTS_DIALOG_ID,
		dialogComponentType: LoginConsentsContainer,
		onClose$: (c) => c.loginError,
		init: (comp) => {
			comp.authMethod = authMethod;
		},
	};
}
